module.exports = __webpack_public_path__ + "static/img/far2.cba7a58f.png";